export interface DoujinCategory {
  slug: string;
  name: string;
  description: string;
  icon: string;
  count: number;
}

export interface DoujinWork {
  slug: string;
  title: string;
  cover: string;
  category: string;
  status: '连载中' | '汉化完成' | '即将开坑';
  tags: string[];
  summary: string;
  latestChapter: string;
  updateTime: string;
  views: number;
  author: string;
  totalChapters: number;
  content: string[];
}

export const categories: DoujinCategory[] = [
  { slug: 'daily', name: '治愈日常', description: '温暖细腻的日常向作品，适合在忙碌间隙慢慢翻阅', icon: 'ri-sun-line', count: 32 },
  { slug: 'fantasy', name: '奇幻冒险', description: '跨越大陆与次元的冒险故事，想象力拉满', icon: 'ri-star-smile-line', count: 27 },
  { slug: 'romance', name: '都市情感', description: '都市背景下的情感描摹与人物纠葛', icon: 'ri-heart-3-line', count: 24 },
  { slug: 'historical', name: '古风志怪', description: '古风韵味与志怪奇谈的交织', icon: 'ri-ancient-pavilion-line', count: 18 },
  { slug: 'sci-fi', name: '科幻未来', description: '面向未来的设定与世界观构筑', icon: 'ri-rocket-2-line', count: 15 },
  { slug: 'mystery', name: '悬疑推理', description: '层层反转的谜题与抽丝剥茧的推理', icon: 'ri-spy-line', count: 12 },
];

export const works: DoujinWork[] = [
  {
    slug: 'xinghai-lvren',
    title: '星海旅人的手帐',
    cover: 'https://readdy.ai/api/search-image?query=softly%20illustrated%20astronaut%20sitting%20on%20a%20hill%20under%20a%20deep%20starry%20night%20sky%2C%20warm%20starlight%20glow%2C%20hand%20drawn%20manga%20style%2C%20cream%20and%20dusty%20rose%20color%20palette%2C%20gentle%20and%20cozy%20atmosphere&width=800&height=1000&seq=dj-cover-01&orientation=portrait',
    category: 'fantasy',
    status: '连载中',
    tags: ['科幻', '治愈', '旅行'],
    summary: '一名在星海间漂泊的旅人，靠着一本手帐记录沿途遇到的人与风景。每一颗星球都有它的故事，而他的旅程才刚刚开始。',
    latestChapter: '第 24 话「灯塔星的一夜」',
    updateTime: '今日更新',
    views: 12840,
    author: '朔月工作室',
    totalChapters: 24,
    content: [
      '星海深处有一颗几乎被遗忘的灯塔星，旅人循着微弱的讯号降落，却发现灯塔已经熄灭了整整七年。',
      '灯塔看守人是一位白发苍苍的老婆婆，她说自己并不孤独——每一盏被她点亮过的灯，都还记着归航的人。',
      '旅人陪她修好了那盏巨大的星灯。当光芒重新照亮夜空时，星海尽头的航船纷纷朝这里聚拢，如同一场迟来的重逢。',
      '临走前，老婆婆送给他一枚小小的徽章：「带着它，无论走多远，这里都会是你的灯火。」',
    ],
  },
  {
    slug: 'yefeng-zhisan',
    title: '夜风与纸伞',
    cover: 'https://readdy.ai/api/search-image?query=ethereal%20ink%20painting%20of%20an%20old%20oiled%20paper%20umbrella%20floating%20in%20the%20night%20wind%2C%20fireflies%2C%20moonlit%20alleyway%2C%20east%20asian%20folklore%2C%20watercolor%20illustration%2C%20dusty%20rose%20and%20deep%20umber%20tones%2C%20dreamy&width=800&height=1000&seq=dj-cover-02&orientation=portrait',
    category: 'historical',
    status: '连载中',
    tags: ['古风', '志怪', '夜谈'],
    summary: '每当夜风拂过，旧城的巷子里总有一把无人撑起的纸伞独自游走。伞下藏着怎样的执念，又为何迟迟不肯离去？',
    latestChapter: '第 16 话「纸鸢与红线」',
    updateTime: '昨日更新',
    views: 9650,
    author: '听雨社',
    totalChapters: 16,
    content: [
      '旧城北街每逢戌时，便会起一阵奇特的夜风。卖馄饨的老陈说，那是纸伞娘娘在找她走丢的孩子。',
      '主角是一名新任的阴阳司录事，初来乍到便接手了这桩悬了二十年的旧案。',
      '他在纸伞里发现了一封泛黄的信，字迹娟秀却语焉不详。沿着线索，一段被刻意掩埋的往事缓缓浮出水面。',
    ],
  },
  {
    slug: 'qingci-xiaoguan',
    title: '青瓷小馆',
    cover: 'https://readdy.ai/api/search-image?query=cozy%20little%20teahouse%20storefront%20with%20celadon%20ceramics%20and%20hanging%20lanterns%2C%20steaming%20tea%2C%20warm%20golden%20interior%20glow%2C%20manga%20background%20art%2C%20sage%20green%20and%20cream%20palette%2C%20inviting%20and%20calm&width=800&height=1000&seq=dj-cover-03&orientation=portrait',
    category: 'daily',
    status: '汉化完成',
    tags: ['日常', '美食', '治愈'],
    summary: '小巷尽头有一家只招待有缘人的青瓷小馆，掌柜话不多，却总能端出最熨帖的一碗。',
    latestChapter: '全 12 话汉化完成',
    updateTime: '3 天前更新',
    views: 18230,
    author: '栖木文库',
    totalChapters: 12,
    content: [
      '小馆的青瓷碗里，盛的从来不只是食物。失意的编辑、赶考的学子、寻亲的老人，都能在这里找到一句被温好的话。',
      '「人间烟火气，最抚凡人心。」掌柜把这句话写在门帘上，落款是二十年前的第一位客人。',
    ],
  },
  {
    slug: 'shanye-wuyu',
    title: '山野物语',
    cover: 'https://readdy.ai/api/search-image?query=whimsical%20forest%20creature%20peeking%20from%20behind%20a%20tree%20in%20a%20lush%20green%20mountain%20woodland%2C%20soft%20morning%20light%2C%20storybook%20manga%20illustration%2C%20moss%20green%20and%20cream%20tones%2C%20gentle%20and%20playful&width=800&height=1000&seq=dj-cover-04&orientation=portrait',
    category: 'daily',
    status: '连载中',
    tags: ['山野', '萌系', '四季'],
    summary: '深山里住着一群不为人知的小精灵，它们随四季更替经营着自己的小日子。春夏秋冬，山野不语，却处处都是故事。',
    latestChapter: '第 30 话「秋收的糖炒栗子」',
    updateTime: '今日更新',
    views: 15270,
    author: '青丘社',
    totalChapters: 30,
    content: [
      '秋天到了，栗子精灵们忙着把满山的板栗运回树洞仓库。偷懒的小栗趁着大家不注意，滚下山坡玩了个尽兴。',
      '当它抱着满兜栗子气喘吁吁赶回来时，伙伴们正围着火堆烤栗子等它。那一夜，甜味从树洞一直飘到山脚。',
    ],
  },
  {
    slug: 'jixie-xinriji',
    title: '机械之心维修日志',
    cover: 'https://readdy.ai/api/search-image?query=steampunk%20robot%20girl%20in%20a%20warmly%20lit%20repair%20workshop%2C%20blueprints%20and%20gears%2C%20manga%20illustration%2C%20terracotta%20and%20cream%20palette%2C%20slightly%20worn%20and%20nostalgic%20atmosphere&width=800&height=1000&seq=dj-cover-05&orientation=portrait',
    category: 'sci-fi',
    status: '连载中',
    tags: ['机娘', '机械', '未来'],
    summary: '一位机械师少女在城市边缘经营着维修铺，专修那些被时代遗忘的老旧机器人。每一具机体里，都藏着一段不肯被删除的记忆。',
    latestChapter: '第 19 话「备份与告别」',
    updateTime: '4 天前更新',
    views: 11390,
    author: '齿轮工房',
    totalChapters: 19,
    content: [
      '客人送来一具型号极老的管家机器人，系统提示记忆模块严重损坏。少女却没有选择重置，而是开始一条一条地修复那些碎片。',
      '原来那是主人为已故母亲保存的全部影像。修复完成的那一刻，客厅里的老收音机轻轻响起了母亲最爱哼的曲子。',
    ],
  },
  {
    slug: 'wudu-zhentan',
    title: '雾都侦探手记',
    cover: 'https://readdy.ai/api/search-image?query=noir%20detective%20silhouette%20in%20a%20foggy%20rainy%20city%20street%20with%20amber%20streetlights%2C%20trench%20coat%20and%20fedora%2C%20manga%20illustration%2C%20dusty%20rose%20and%20charcoal%20tones%2C%20moody%20and%20atmospheric&width=800&height=1000&seq=dj-cover-06&orientation=portrait',
    category: 'mystery',
    status: '连载中',
    tags: ['推理', '悬疑', '雾都'],
    summary: '终年笼罩在浓雾中的滨海旧城，一名私家侦探与他的助手，在每一桩看似寻常的案件里发现藏在雾后的真相。',
    latestChapter: '第 11 话「雾中的钟楼」',
    updateTime: '昨日更新',
    views: 8760,
    author: '苍鸦事务所',
    totalChapters: 11,
    content: [
      '案件现场没有任何入侵痕迹，唯一的目击者却坚称看到了「不存在的第十二个人」。',
      '侦探绕着钟楼走了一圈又一圈，最终在整点报时的间隙里，找到了那个被时间掩盖的答案。',
    ],
  },
  {
    slug: 'yuexia-jishi',
    title: '月下集市',
    cover: 'https://readdy.ai/api/search-image?query=enchanting%20night%20market%20bazaar%20under%20a%20huge%20full%20moon%2C%20colorful%20stalls%20and%20lanterns%2C%20fantasy%20creatures%20shopping%2C%20manga%20illustration%2C%20warm%20gold%20and%20dusty%20rose%20palette%2C%20magical%20and%20lively&width=800&height=1000&seq=dj-cover-07&orientation=portrait',
    category: 'fantasy',
    status: '汉化完成',
    tags: ['夜市', '妖精', '奇幻'],
    summary: '每月十五月圆之夜，无人知晓的集市会在旧街尽头开张。那里的摊主都是妖精，贩卖的则是凡人求而不得的愿望。',
    latestChapter: '全 8 话汉化完成',
    updateTime: '5 天前更新',
    views: 20140,
    author: '长庚社',
    totalChapters: 8,
    content: [
      '在月下集市，你可以买到「一个月的勇气」「一夜安眠」或「忘掉某件事的清晨」。',
      '但掌柜从不卖「后悔」——因为那件货，早在集市开张那天就被他自己买走了。',
    ],
  },
  {
    slug: 'yingtao-siji',
    title: '樱与町的四季',
    cover: 'https://readdy.ai/api/search-image?query=cherry%20blossom%20town%20street%20in%20spring%2C%20petals%20drifting%2C%20small%20town%20with%20wooden%20houses%2C%20manga%20illustration%2C%20soft%20blush%20pink%20and%20cream%20palette%2C%20nostalgic%20and%20peaceful&width=800&height=1000&seq=dj-cover-08&orientation=portrait',
    category: 'romance',
    status: '连载中',
    tags: ['青春', '小镇', '恋爱'],
    summary: '返乡青年回到记忆中的小镇，与旧友一起重新经营起祖传的文具店。四季流转，那些没说出口的话，终于有了落脚的时机。',
    latestChapter: '第 22 话「盛夏的明信片」',
    updateTime: '今日更新',
    views: 14110,
    author: '纸短情长社',
    totalChapters: 22,
    content: [
      '夏日的午后，店门口的信箱里多了一张没有署名的明信片，背面只有一句「还记得你说过的那个约定吗」。',
      '主角握着明信片站了很久，窗外的蝉鸣一声接一声，像在替某个迟迟不敢开口的人，把话说了出来。',
    ],
  },
  {
    slug: 'guiyu-zhuan',
    title: '归屿札记',
    cover: 'https://readdy.ai/api/search-image?query=lonely%20island%20with%20a%20small%20lighthouse%20surrounded%20by%20gentle%20waves%2C%20sailboat%20approaching%2C%20ink%20wash%20style%2C%20teal%20and%20cream%20manga%20illustration%2C%20wistful%20and%20serene&width=800&height=1000&seq=dj-cover-09&orientation=portrait',
    category: 'historical',
    status: '即将开坑',
    tags: ['海岛', '归乡', '信'],
    summary: '战乱离散多年后，幸存的族人在一座孤岛上重建家园，靠着一封封没有寄出的信，把散落四方的记忆一一唤回。',
    latestChapter: '预计本周内开坑',
    updateTime: '即将上线',
    views: 6230,
    author: '南海旧书铺',
    totalChapters: 0,
    content: [
      '筹备中的长篇连载，首话将于本周发布。一座岛、一沓信、一个被时间冲散的家族，欢迎见证它们的重聚。',
    ],
  },
  {
    slug: 'dianqi-zaji',
    title: '点心杂记',
    cover: 'https://readdy.ai/api/search-image?query=delicate%20chinese%20pastries%20and%20buns%20arranged%20on%20bamboo%20steamer%2C%20warm%20kitchen%20light%2C%20food%20illustration%2C%20manga%20style%2C%20golden%20and%20cream%20palette%2C%20appetizing%20and%20cozy&width=800&height=1000&seq=dj-cover-10&orientation=portrait',
    category: 'daily',
    status: '汉化完成',
    tags: ['美食', '点心', '日常'],
    summary: '关于一家百年点心铺的四代人的故事。炉火不息，手艺相传，每一笼蒸腾的热气里都盛着市井的温度。',
    latestChapter: '全 15 话汉化完成',
    updateTime: '6 天前更新',
    views: 16890,
    author: '醒狮轩',
    totalChapters: 15,
    content: [
      '铺子最老的规矩只有一条：宁可少卖一笼，也不让客人吃到隔夜的面。',
      '正是这条规矩，让几代人在起起落落里，始终守住了老街坊们的胃与心。',
    ],
  },
  {
    slug: 'xingchen-shouhu',
    title: '星辰守夜人',
    cover: 'https://readdy.ai/api/search-image?query=mysterious%20cloaked%20figure%20on%20a%20tower%20watching%20over%20a%20glowing%20constellation%20sky%2C%20manga%20illustration%2C%20indigo%20night%20and%20warm%20gold%20accent%2C%20epic%20and%20quiet&width=800&height=1000&seq=dj-cover-11&orientation=portrait',
    category: 'sci-fi',
    status: '连载中',
    tags: ['星空', '守护', '热血'],
    summary: '当星辰开始一颗颗熄灭，被选中的少年守夜人踏上收集星火的旅途。散落在各处的星火，也牵引着他身世之谜的答案。',
    latestChapter: '第 27 话「熄灭的第七颗星」',
    updateTime: '2 天前更新',
    views: 19780,
    author: '北辰工作室',
    totalChapters: 27,
    content: [
      '第七颗星熄灭的那晚，少年第一次见到了传说中行走于星空的守夜人前辈。',
      '「你收集的不是星火，」前辈说，「而是世界还没讲完的那部分故事。」',
    ],
  },
  {
    slug: 'fanhua-luying',
    title: '繁花路影',
    cover: 'https://readdy.ai/api/search-image?query=two%20young%20people%20on%20a%20boulevard%20lined%20with%20blooming%20pink%20flowers%2C%20back%20to%20back%20walking%20away%2C%20manga%20illustration%2C%20blush%20and%20cream%20palette%2C%20bittersweet%20and%20cinematic&width=800&height=1000&seq=dj-cover-12&orientation=portrait',
    category: 'romance',
    status: '即将开坑',
    tags: ['都市', '相遇', '命运'],
    summary: '同一条繁华街路上，两个陌生人反复擦肩而过。直到某天一场意外的停电，让他们的生活终于产生了交集。',
    latestChapter: '预告篇已放出',
    updateTime: '即将上线',
    views: 7450,
    author: '折光社',
    totalChapters: 1,
    content: [
      '预告篇讲述了一个关于「错过与重逢」的命题：当生活按下暂停键，那些被忽略的平行轨迹，才会真正开始交汇。',
    ],
  },
];